import Vue from "vue";
import Vuex from "vuex";
import news from "./modules/news";
import language from "./modules/language";
import system from "./modules/system";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    news,
    language,
    system,
  },
});
